export const rangeTypes = {
  custom: 'custom',
  walk: 'walk',
  car: 'car',
  line: 'line',
  bike: 'bike',
}
